export default __webpack_public_path__ + "static/media/Lily Mei Mayor .bd3f91f5.jpg";